<div class="gradient">
  <div class="signup_wrapper row  p-3 mb-5 ">
    <div class="signup_left_content col-6 bg-white shadow">
      @if (showLogin) {
        <div>
          <app-mobile-input (onOTPRequest)="showLogin = false; showOTPVerification = true;"
          (phoneNumber)="getUserPhone($event)"></app-mobile-input>
        </div>
      }

      @if (showOTPVerification) {
        <div>
          <app-otp-verification [phone]="phone" (back)="showOTPVerification=false; showLogin = true;" (loggedIn)="userLoggedIn($event)"></app-otp-verification>
        </div>
      }
      <p class="t-c">
        {{ translationService.instant('auth.signupAgreementPrefix','By signing up, you agree to our') }}
        <b><a [href]="termsUrl" target="_blank">{{
            translationService.instant('auth.terms','Terms & Conditions') }}</a></b>
        {{ translationService.instant('auth.and','and') }}
        <b><a [href]="privacyUrl" target="_blank">{{
            translationService.instant('auth.privacy','Privacy Policy') }}</a></b>
      </p>
    </div>
    <div class="signup_right_content col-6 ">
      <app-img-slider></app-img-slider>
    </div>
  </div>
</div>